/**
 * Just constants regarding styles
 */

// Colors : https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/overview/global-colour-palette
export const colors = {
  transparent: 'transparent',

  red: '#DC1928',
  grey: '#382F2D',
  white: 'white',

  // Success Green https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/components/nav-stepper
  success: '#067A3D',
  // Current Blue https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/components/nav-stepper
  current: '#0D72A8',

  // Other reds for different states of components
  hoverRed: '#EE2D3C',
  activeRed: '#BC111E',
  errorRed: '#DC1928',

  // Digital Tertiary (Warm greys)
  warmGrey1: '#F9F8F7',
  warmGrey2: '#F3F1EE',
  warmGrey3: '#E2DFDA',
  warmGrey4: '#807370',
  warmGrey5: '#5E514D',

  /** Same as warmgrey4 */
  textColor: '#807370',
  /** Same as grey */
  headingColor: '#382F2D',

  // Digital Tertiary (Cool greys)
  coolGrey1: '#F3F4F5',
  coolGrey2: '#D0D5D8',
  coolGrey3: '#66727A',
  coolGrey4: '#535F67',
  coolGrey5: '#2D3238',
};

export const spacing = {
  verticalBetweenFields: 24,
  horizontalBetweenFields: 24,

  /**
   * Used as a page body padding + padding between sections
   */
  betweenPageSections: 24,
}

/**
 * https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/sections/breakpoints
 * But just two
 */
export const breakpoints = {
  /** Phone */
  sm: 480,
  /** Tablet */
  lg: 970,
  // Anything else is normal
}

/**
 * You normally don't want to provide a too wide UI even if the user has a big wide screen
 * So we limit the screens to this width based on the prototypes
 * NOTE: this number came from auspost sketch files width
 */
export const maxPageContentWidth = 960;
export const maxLandingPageWidth = 1600;
/**
 * For form pages we want the content limited to this width.
 * NOTE: this number came from auspost sketch files width
 */
export const maxFormContentWidth = 610;
/**
 * For simple dialog pages e.g. Login
 */
export const maxDialogContentWidth = 350;


/**
 * I couldn't find one in the styleguide so I copied from bootstrap
 * http://v4-alpha.getbootstrap.com/content/typography/
 */
export const fontSizes = {
  h1: '36px',
  h2: '30px',
  h3: '24px',
  h4: '18px',
  h5: '15px',
  h6: '12px',

  /** AP font needs this line height */
  apLineHeight: 1.25,

  paragraph: '15px',
  label: '15px',
  buttonText: '15px',

  smallText: '12px',
}

/**
 * Auspost font families
 */
export const fontFamily = {
  /** Used for most headings / headers etc. */
  auspost: "ap_letter, Arial, Lato, 'Helvetica Neue', Helvetica, sans-serif",
  /** Used for labels and some copy text etc */
  arial: 'ArialMT, Arial, sans-serif',
}
